
<!-- Wrapper Body -->
<div class="wrapper-body">
    <div class="page-header d-flex align-items-center">
      <h3>Hold Appointments</h3>
      <a href="javascript:void" class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
      <button type="button" class="theme-button grey mr-md-3 my-3 my-md-0" onclick="exportCSV()">Export to CSV</button>
    </div>
    <div class="content" >
      <form class="custom-form d-none" [formGroup]="filterForm" id="filterShow">
        <div class="row">
          <!-- <div class="col-md-4">
            <input type="text" id="filterSearch" placeholder="Type here to search"
              onkeyup="appointmentFilterFunction()">
          </div> -->
          <div class="col-md-3">
            <input type="text" formControlName="fromDate" placeholder="From Date" min="2022-01-01" max="3000-01-01" onfocus=" this.type='date'">
          </div>
          <div class="col-md-3">
            <input type="text" formControlName="toDate" placeholder="To Date" min="2022-01-01" max="3000-01-01" onfocus=" this.type='date'">
          </div>
          <div class="col-md-2">
            <button type="button" form="intakeForm" fo class="theme-button" id="dateRangeFilter" (click)="submitFilterForm()">Search</button>
          </div>
        </div>
      </form>
      <div class="card" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") '>
        <div class="table-responsive">
          <!-- <table class="custom-table filterTable" id="appointmentTable"> -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="appointmentTable" class="custom-table filterTable row-border hover">
            <thead>
              <tr class="header">
                <th style="display: none;">Id</th> 
                <th>Client Name</th>
                <th>Cell Number</th>
                <th>Email</th>
                <th>Assessment Type</th>
                <th>Appt. Date</th>
                <th>Appt. Time</th>
                <th>Action</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loop -->
              <tr *ngFor="let appointment of appointments; let i = index">
                <td  style="display: none;">{{i}}</td> 
                <td>{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
                <td>{{appointment.parentDetails.cellNumber}}</td>
                <td>{{appointment.parentDetails.emailAddress}}</td>
                <td class="">{{appointment.appointmentDetails.assesmentType}}</td>
                <td class="" [attr.data-order]="getSortableDate(appointment.appointmentDetails.schedules[0].appointmentDate)">{{appointment.appointmentDetails.schedules[0].appointmentDate | abbreviatedMonthDate}}</td>
                <td class="" [attr.data-order]="getSortableTime(appointment.appointmentDetails.schedules[0].appointmentTime)">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</td>
                <!-- <td><a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]">View Details</a></td>             -->
                <td><a href="javascript:void(0)" data-toggle="modal" data-target="#UnholdApptModal"
                  class="ml-auto px-3 py-2 badge bg-purple text-white float-md-right"
                 (click)="updateApptId(appointment.appointmentDetails.appointmentId)" >Unhold</a>
                  
                 
                 
              </td>
              <td> <a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]">View</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card" *ngIf='userRole=="DIAGNOSTIC" '>
        <div class="table-responsive">
          <!-- <table class="custom-table" id="appointmentTable"> -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="" class="custom-table filterTable row-border hover">
            <thead>
              <tr class="header">
                <th style="display: none;">Id</th> 
                <th>Client Name</th>
                <th>Cell Number</th>
                <th>Email</th>
                <th>Assessment Type</th>
                <th>Appt. Date</th>
                <th>Appt. Time</th>
                <th>Comments</th>
              </tr>
            </thead>
            <tbody>
  
              <!-- Loop -->
              <tr *ngFor="let appointment of appointments;let i = index">
                <td  style="display: none;">{{i}}</td> 
                <td>{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
                <td>{{appointment.parentDetails.cellNumber}}</td>
                <td>{{appointment.parentDetails.emailAddress}}</td>
                <td class="">{{appointment.appointmentDetails.assesmentType}}</td>
                <td class="" [attr.data-order]="getSortableDate(appointment.appointmentDetails.schedules[0].appointmentDate)">{{appointment.appointmentDetails.schedules[0].appointmentDate | abbreviatedMonthDate}}</td>
                <td class="" [attr.data-order]="getSortableTime(appointment.appointmentDetails.schedules[0].appointmentTime)">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</td>
                <td class="">{{appointment.appointmentDetails.assesmentComments}}</td>
             </tr>
  
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="appointments?.length<1">
         <div class="row">
          <div class="col-12">
            <div class="card py-5 px-2 text-center">
              <h4 class="text-grey">No Hold Appointments</h4>
              <!-- <p class="text-grey mb-0">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  
    
  </div>
  
  
  <!-- hold appt modal -->

<div class="modal fade" id="UnholdApptModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
aria-labelledby="UnholdApptModal" aria-hidden="true">
<div class="modal-dialog">
    <div class="modal-content light px-5 py-4">
        <h6 class="mb-4 text-center">Are you sure you want to unhold this appointment?</h6>
        <div class="action text-center">
            <button type="submit" (click)="HoldAndUnHoldAppt('UNHOLD')" data-dismiss="modal"
                class="theme-button danger mx-2">Yes, Unhold</button>
            <a href="#!" class="theme-button grey mx-2"  data-dismiss="modal">Back</a>
        </div>
    </div>
</div>
</div>
  
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>